import React, {Component} from "react";
import CdmLayout from "../../../../templates/cdm";
import {NavLink} from "react-router-dom";
import _ from "lodash";
import tasksList from "./../../../json/current_tasks";
import * as moment from "moment";
import DatePicker from "react-datepicker/es";
import TextEditor from "../../../../elements/forms/wysiwyg_field";
import BigFileUpload from "../../../../elements/widgets/big_file_upload";

export class CdmPlanningEdit extends Component {
	render() {
		const task = tasksList.data[0];
		return (<div className="columns is-centered">
			<div className="column is-10">
				<form id="process-form">
					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="process" className="label">Proceso</label>
							<div className="select">
								<select>
									<option value={0} disabled selected>--- Proceso ---</option>
									<optgroup label="Procesos sustantivos">
										<option selected value={1}>Detectar</option>
										<option value={2}>Integrar</option>
										<option value={3}>Formar</option>
										<option value={4}>Acompañar</option>
										<option value={5}>Reconocer</option>
									</optgroup>
									<optgroup label="Procesos de soporte">
										<option value={6}>Planear</option>
										<option value={7}>Coordinar</option>
										<option value={8}>Gestionar</option>
									</optgroup>
								</select>
							</div>
						</div>

						<div className="control is-expanded">
							<label htmlFor="name" className="label">Subproceso</label>
							<div className="select is-fullwidth">
								<select name="name" id="name">
									<option value={0} selected disabled>--- Subproceso ---</option>
									<option value={1} selected>Identificar instituciones, programas y servicios</option>
									<option value={2}>Identificar actores/as sociales, usuarias/os con potencial de líder e infraestructura en el municipio</option>
								</select>
							</div>
						</div>
					</div>

					<div className="field">
						<div className="control">
							<label htmlFor="objective" className="label">Objetivo</label>
							<TextEditor ref="objective" id="objective" placeholder="Políticas y lineamientos" value={task.purpose} onChange={(value) => console.log(value)} />
						</div>
					</div>
					
					<div className="field">
						<div className="control">
							<label htmlFor="rules" className="label">Políticas / Lineamientos</label>
							<TextEditor ref="rules" id="rules" placeholder="Políticas y lineamientos" value={task.rules} onChange={(value) => console.log(value)} />
						</div>
					</div>

					<div className="field">
						<div className="control">
							<label htmlFor="report" className="label">Datos a reportar</label>
							<TextEditor ref="report" id="report" placeholder="Datos a reportar" value={task.report_info} onChange={(value) => console.log(value)} />
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="start_date" className="label">Fecha inicio</label>
							<DatePicker className="input" name="start_date" ref="start_date" dateFormat="YYYY-MM-DD" selected={this.state.start_date} placeholderText={moment().format('YYYY-MM-DD')} onChange={(date) => console.log(date)} />
						</div>

						<div className="control">
							<label htmlFor="end_date" className="label">Fecha fin</label>
							<DatePicker className="input" name="end_date" ref="end_date" dateFormat="YYYY-MM-DD" selected={this.state.end_date} placeholderText={moment().format('YYYY-MM-DD')} onChange={(date) => console.log(date)} />
						</div>
					</div>

					<hr/>

					<div className="columns">
						<div className="column">
							<h6 className="title is-5">Pasos</h6>
						</div>
						<div className="column">
							<div className="field is-pulled-right">
								<div className="control">
									<a href="/cdm" className="button is-cdm-light-blue">Agregar paso</a>
								</div>
							</div>
						</div>
					</div>

					{_.map(task.tasks, (act, a) => {
						return <div className="hero is-light" style={{marginBottom: '10px'}} key={`task-activity-${a}`}>
							<div className="hero-body">
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor={`step-${a}`} className="label">Paso {a + 1}</label>
										<input value={act.title} type="text" id={`step-${a}`} name={`step-${a}`} className="input" onChange={(value) => console.log(value)} disabled />
									</div>

									<div className="control">
										<label htmlFor="responsible" className="label">Responsable</label>
										<input type="text" className="input" value={act.role.name} disabled />
									</div>

									<div className="control">
										<label htmlFor="days" className="label">Días para completar</label>
										<input type="number" name="days" id="days" className="input" value={act.duration} />
									</div>
								</div>

								<div className="field">
									<div className="control">
										<label htmlFor="desc" className="label">Descripción</label>
										<TextEditor ref="desc" id="desc" placeholder="Descripción detallada" value={act.description} onChange={(value) => console.log(value)} />
									</div>
								</div>

								<h6 className="title is-6">Entregables</h6>
								<div className="field is-grouped is-grouped-multiline">
									<div className="control">
										<label htmlFor="3" className="checkbox">
											<input type="checkbox" id="3" />
											Mapa con polígonos
										</label>
									</div>

									<div className="control">
										<label htmlFor="4" className="checkbox">
											<input type="checkbox" id="4" />
											Directorio usuarios/as con potencial de líder y actores sociales
										</label>
									</div>

									<div className="control">
										<label htmlFor="1" className="checkbox">
											<input type="checkbox" id="1" />
											Directorio de instituciones
										</label>
									</div>

									<div className="control">
										<label htmlFor="2" className="checkbox">
											<input type="checkbox" id="2" />
											Directorio de programas y servicios
										</label>
									</div>

									<div className="control">
										<label htmlFor="5" className="checkbox">
											<input type="checkbox" id="5" />
											Lista de asistencia
										</label>
									</div>

									<div className="control">
										<label htmlFor="6" className="checkbox">
											<input type="checkbox" id="6" />
											Inventario de materiales
										</label>
									</div>

									<div className="control">
										<label htmlFor="7" className="checkbox">
											<input type="checkbox" id="7" />
											Evidencia fotográfica
										</label>
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="file-name" className="label">Nombre</label>
										<input type="text" id="file-name" name="file-name" value="Formato 1" className="input" />
									</div>
									<div className="control">
										<label htmlFor="file" className="label">Agregar descargable</label>
										<BigFileUpload name="Descargable" model="project.file" />
									</div>
									<div className="control">
										<label htmlFor="file-list" className="label">Formatos vinculados</label>
										<p>
											<i className="fa fa-download" style={{marginRight: '10px'}} />
											<a href="file.docx" download="formato_descargable.docx">Formato 1</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					})}

					<div className="colmuns no-margin">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<NavLink className="button is-large" to="/cdm/planeacion">Regresar</NavLink>
								</div>
								<div className="control">
									<button onClick={() => console.log(this.state)} className="button is-cdm-blue is-large" type="button">Guardar</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>);
	}

	constructor() {
		super();
		this.state = {
			start_date: moment('2018-09-10'),
			end_date: moment('2018-09-21'),
			objective: 'Conocer el universo de programas, servicios y recursos públicos disponibles a nivel municipal, estatal y nacional, particularmente dirigidos a las mujeres.',
			rules: '<p>Cada que se requiera, verificar que la información de las instituciones, programas y servicios siga vigente; en caso contrario se complementará y/o actualizará.</p> <p>Integrar al catálogo de instituciones, todos aquellos programas y servicios nuevos que se identifiquen.</p>',
			report: '<p>Programs y servicios disponibles para las mujeres en el municipio.</p><ul><li>Descripción general</li><li>Dirección</li><li>Responsables: nombre completo, cargo, número de teléfono y cuenta de correo</li><li>Requisitos para participar</li></ul>',
			step1: '<p>Revisar el mapa del municipio reconociendo sus características y lo dividirá en polígonos que le permitan trabajar en zonas más pequeñas, programar recorridos y actividades en cada uno.</p>'
		}
	}
}

export default CdmLayout(CdmPlanningEdit, {
	title: 'Editar subproceso',
	subnav: {
		icon: 'fa-calendar-check-o',
		name: 'Editar subproceso',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/support/planning/edit.jsx